import { render, staticRenderFns } from "./BottomNavMobile.vue?vue&type=template&id=7631ed7a"
import script from "./BottomNavMobile.vue?vue&type=script&lang=js"
export * from "./BottomNavMobile.vue?vue&type=script&lang=js"
import style0 from "./BottomNavMobile.vue?vue&type=style&index=0&id=7631ed7a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports